import Cta from "../../fragments/cta/Cta";
import Icon from "../../fragments/icon/Icon";

export default function TicketsPanel({ ticket }) {
  // console.log(ticket);
  return (
    <div className={"Tickets-panel"}>
      {ticket.icon && <Icon icon={ticket.icon} iconColor={"light"} />}
      {ticket.heading && (
        <h3 className="h6 Tickets-heading">{ticket.heading}</h3>
      )}
      {ticket.description && (
        <p className="Tickets-description"> {ticket.description}</p>
      )}
      {(ticket.cta || ticket.ctaSecondary) && (
        <div className="Tickets-ctas">
          {ticket.cta && <Cta cta={ticket.cta} theme={"secondary"} />}
          {ticket.ctaSecondary && <Cta cta={ticket.ctaSecondary} />}
        </div>
      )}
    </div>
  );
}
